import registerContentLoaders from '@/js/App/PdModal/registerContentLoaders'
import { controlManager } from '@/js/Controls'
import { Spinner } from '@/js/UI/Components/Spinner'
import PdModal from '@peckadesign/pd-modal'
import * as React from 'jsx-dom'

export const modal = new PdModal({
	className: 'prose',

	spinner: Spinner({
		overlay: true,
		sticky: true
	}),
	template: function (this: PdModal): HTMLElement {
		const i18n = this.i18n[this.options.language]

		return (
			<div
				class="pd-modal"
				id="pdModal"
				aria-hidden="true"
				aria-labelledby="snippet--pdModalTitle"
				aria-describedby="snippet--pdModalPerex"
			>
				<div class="pd-modal__overlay" data-a11y-dialog-hide={true}></div>
				<div class="pd-modal__window" role="document">
					<div class="pd-modal__dialog ajax-wrap">
						<header class="pd-modal__header container grid gap-x-1">
							<button
								type="button"
								data-a11y-dialog-hide={true}
								class="pd-modal__close grid-area-[cta] shrink-0 order-1 ml-auto"
								aria-label={i18n.close}
							>
								<i class="icon icon--close" aria-hidden="true"></i>
								<span class="sr-only">{i18n.close}</span>
							</button>

							<h1 class="pd-modal__title grid-area-[heading] m-0" id="snippet--pdModalTitle">
								{i18n.defaultTitle}
							</h1>

							<p
								id="snippet--pdModalPerex"
								className="pd-modal__lead grid-area-[perex] order-2 w-full mb-0 empty:hidden"
							></p>
						</header>

						<div class="pd-modal__content container mx-0" id="snippet--pdModal"></div>
					</div>
				</div>
			</div>
		) as HTMLElement
	}
})

// Setup content loaders; delegated to function in a separate file, so it can be overloaded on B2B
registerContentLoaders(modal)

// Automatically scroll to the top of the modal when content is loaded
modal.addEventListener('load', (event) => {
	const originalEvent = event.detail.event as CustomEvent | undefined

	if (originalEvent && originalEvent.detail?.payload?.forceRedirect) {
		return
	}

	modal.window.scrollTop = 0
})

modal.addEventListener('beforeClose', () => {
	controlManager.destroy(controlManager.onLiveControl, modal.content)
})
